import {DEMO_MONEY} from 'app/utils/Consts';

export const isDemoMoney = (type: string): boolean => type === DEMO_MONEY;
